<div
  id="footer"
  class="flex items-center w-full h-full text-white text-sm"
  [ngClass]="[switchColor ? 'bg-black' : 'bg-main-dark']">
  <div class="flex justify-between items-center w-full">
    <div class="flex-1 text-center">
      {{ configurationService.configuration.footerExtraText }}
      For questions or assistance, please call
      <b>{{ configurationService.configuration.phone }}</b> or email
      <b>{{ configurationService.configuration.email }}</b>
    </div>
    <div class="flex-initial">
      <span class="mr-5 text-xs whitespace-nowrap"
        >Version: {{ appPackage.version }}</span
      >
    </div>
  </div>
</div>
